import { useLayoutEffect } from 'react'

export const useScrollLock = (
  target: HTMLElement,
  options: { disabled?: boolean } = {},
) => {
  useLayoutEffect(() => {
    if (options.disabled) return

    const currentTarget = target
    const previousOverflow = currentTarget.style.overflow
    currentTarget.style.overflow = 'hidden'
    return () => {
      currentTarget.style.overflow = previousOverflow
    }
  }, [options.disabled, target])
}
